/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Požadované množství již není k dispozici`
};

const da_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Den ønskede mængde er ikke længere tilgængelig`
};

const de_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Die gewünschte Menge ist nicht mehr verfügbar`
};

const en_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `The demanded quantity is no longer available`
};

const es_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `La cantidad solicitada ya no está disponible`
};

const fr_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `La quantité demandée n'est plus disponible`
};

const hu_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `A kért mennyiség már nem elérhető`
};

const it_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `La quantità richiesta non è più disponibile`
};

const nl_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `De gevraagde hoeveelheid is niet meer beschikbaar`
};

const pl_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Żądana ilość nie jest już dostępna`
};

const pt_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `A quantidade solicitada não está mais disponível`
};

const sv_cart_errors_quantity = /** @type {(inputs: {}) => string} */ () => {
	return `Den begärda mängden är inte längre tillgänglig`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const cart_errors_quantity = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cart_errors_quantity(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("cart_errors_quantity", locale)
	if (locale === "cs") return cs_cart_errors_quantity(inputs)
	if (locale === "da") return da_cart_errors_quantity(inputs)
	if (locale === "de") return de_cart_errors_quantity(inputs)
	if (locale === "en") return en_cart_errors_quantity(inputs)
	if (locale === "es") return es_cart_errors_quantity(inputs)
	if (locale === "fr") return fr_cart_errors_quantity(inputs)
	if (locale === "hu") return hu_cart_errors_quantity(inputs)
	if (locale === "it") return it_cart_errors_quantity(inputs)
	if (locale === "nl") return nl_cart_errors_quantity(inputs)
	if (locale === "pl") return pl_cart_errors_quantity(inputs)
	if (locale === "pt") return pt_cart_errors_quantity(inputs)
	return sv_cart_errors_quantity(inputs)
};
export { cart_errors_quantity as "cart_errors.quantity" }